import React, { useState } from 'react';
import { useUser, useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

const UserMenu = () => {
  const { user } = useUser();
  const { signOut } = useClerk();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleSignOut = async () => {
    // stamp localStorage so other tabs see it
    localStorage.setItem('clerk-signout', Date.now().toString());
    // perform Clerk sign-out
    await signOut();
    // redirect current tab
    navigate('/');
  };

  return (
    <div className="relative">
      <img
        src={`${process.env.PUBLIC_URL}/assets/profileImage.jpg`}
        onClick={() => setOpen(o => !o)}
        className="w-10 h-10 rounded-full cursor-pointer"
        alt="User avatar"
      />
      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-white rounded-md shadow-lg z-50">
          {/* Styled greeting */}
          <div className="px-4 py-2 text-gray-700 font-medium border-b">
            Hello, {user.username}
          </div>
          <button
            onClick={() => { navigate('/history'); setOpen(false); }}
            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            History
          </button>
          <button
            onClick={() => { navigate('/settings'); setOpen(false); }}
            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            Manage Profile
          </button>
          <button
            onClick={handleSignOut}
            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
